import {
  pgSchema,
  boolean,
  timestamp,
  jsonb,
  text,
  varchar,
} from "drizzle-orm/pg-core"
import { ulidId } from "./shared"

export const sesSchema = pgSchema("ses")

export const notificationHistory = sesSchema.table("notification_history", {
  id: ulidId().notNull().primaryKey(),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  messageId: text("message_id").notNull(), // Message ID from SES API
  responseStatusCode: varchar("response_status_code").notNull(),
  mailToAddresses: jsonb("mail_to_addresses").notNull(),
  mailSubject: text("mail_subject"),
  mailBody: text("mail_body"),
  mailMetadata: jsonb("mail_metadata"),
  mailProcessedDate: timestamp("mail_processed_date").notNull(),
  sesTemplateName: text("ses_template_name"), // If template used
  sesTemplateData: text("ses_template_data"), // If template used
  hasAttachment: boolean("has_attachment").notNull().default(false),
  attachmentPath: text("attachment_path"), // Full file path in s3
})
